// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pvEjI","question":"styles_question__3uUx0","description":"styles_description__2h8u-"};